import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        
        <div className="prose prose-gray dark:prose-invert max-w-none">
          <h1 className="text-3xl font-bold mb-8">Cookie Policy</h1>
          
          <div className="space-y-6">
            <p>We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Keep you logged in (essential)</li>
              <li>Analyze site usage with PostHog (analytics)</li>
              <li>Remember your preferences (functional)</li>
            </ul>
            
            <p>
              Analytics cookies help us improve the product by understanding how users interact with features. 
              You can disable these in your browser settings.
            </p>
            
            <p>
              For more details, see our Privacy Policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;